<span
  class="icon-inline"
  v-tooltip.bottom="tooltipOptions"
>
  <ClassicSvg :style="svgStyle" />
</span>
